/** - Este Script se encarga de ayudar a documentar y hacer funcionar correctametne 
 * el InteliSense de Visual Studio code con el resto del codigo de los demas .js
 * @author Agustin Parodi - IGM (Sección: SIG)
 */

import {ConfigJSON} from './Config'

/** widnow element pero documentable
 * @typedef {Window & Globals} ExtendedWindow
 * @typedef {Object} Globals
 * @prop {boolean} [__myFlag__]
 * @prop {Number} [__myFlag2__]
 *
 * <VARIABLES RECURSOS>
 * @prop {Recursos} Recursos - elemento global con los recursos (RECURSOS)
 * 
 * <VARIABLES GLOBALS>
 * @prop {ConfigJSON} OptionsJSON - Objeto JSON de opciones codificado para inteliSense
 * @prop {string} Version - Version actual del visualizador, se muestra en la interface (globals.js)
 * @prop {boolean} isMobile - Devuelve si actualmente la ap se esta ejecutando en un Celular o no (globals.js)
 * @prop {string} Version - Version actual del visualizador, se muestra en la interface (globals.js)
 * @prop {string} LastUpdateDate - Fecha de la ultima vez que se cambio la version, se muestra en la interface (globals.js)
 * @prop {string} ProgramadorPrincipal - Programador Principal del proyecto (globals.js)
 * @prop {string} SegundoProgramador - Segundo programador del proyecto (globals.js)
 * @prop {string} ApoyoSIG Encargado del desplegue de las capas en GeoServer y ArcGIS Server (globals.js)
 * @prop {string} Credits - Creditos Del Proyecto "institucionales" (globals.js)
 * @prop {string} Creditos - Creditos Del Proyecto Internos (globals.js)
 * @prop {string} creditos - Creditos Del Proyecto Internos (globals.js)
 * @prop {string} Creadores - Creditos Del Proyecto Internos (globals.js)
 * @prop {string} creadores - Creditos Del Proyecto Internos (globals.js)
 * @prop {string} Contributors - Creditos Del Proyecto Internos (globals.js)
 * @prop {string} contributors - Creditos Del Proyecto Internos (globals.js)
 * @prop {string} Creators - Creditos Del Proyecto Internos (globals.js)
 * @prop {string} creators - Creditos Del Proyecto Internos (globals.js)
 * 
 * <VENTANAS>
 * @prop {HTMLElement} VentanaCrearCapa - VENTANA de crear capa
 * @prop {HTMLElement} VentanaEliminarCapa - VENTANA de Eliminar capa
 * @prop {HTMLElement} VentanaDescargarCapa - VENTANA de descargar capa
 * @prop {HTMLElement} VentanaSubirCapa - VENTANA de subir capa desde archivo
 * @prop {HTMLElement} VentanaPrintPNG - VENTANA de Imprimir a PNG
 * @prop {HTMLElement} VentanaEditar - VENTANA de Comenzar Edicion
 * @prop {HTMLElement} VentanaOpciones - VENTANA de Opciones
 * @prop {HTMLElement} VentanaCargarWMS - VENTANA de Cargar WMS
 * @prop {HTMLElement} VentanaComprobarInformacion - VENTANA de Pedir Info 
 * @prop {HTMLElement} VentanaComprobarInformacionFisrtTime - VENTANA de Pedir Info First Time
 * @prop {HTMLElement} VentanaCapasDelIGM - VENTANA de Capas del igm - Deprecated
 * @prop {HTMLElement} VentanaExportandoMapa - VENTANA de Exportar Mapa como PDF, sin implementar
 * @prop {HTMLElement} VentanaTips - VENTANA de Ayuda Rapida
 * @prop {HTMLElement} VentanaAyuda - VENTANA de Ayuda
 * @prop {HTMLElement} VentanaMetadatos - VENTANA de Metadatos
 * 
 * @prop {HTMLElement} operationWindow - Esta es la ventana de operacion (la que solo dice Aceptar o SI/NO)
 * 
 * <VARIABLES INTEFRACE>
 * @prop {number} InterfaceColor - Numero que representa el color de la interface (INTERFACE)
 * @prop {number} InterfaceBG - Numero que representa el fondo seleccionado (INTERFACE)
 * @prop {number} standarToolTipDelayInMS - Valor Estandar para Retraso en MS para que aparezca el tooltip, se usa como valor por defecto (INTERFACE)
 * @prop {HTMLelement} ToolTipElem - Elemento HTML que tiene el bloque de tooltips, se usa para mostrar los tooltips
 * @prop {string} operationWindow - ventana de operacion, se usa para las comprobaciones de bloqueo de las funciones de capas (INTERFACE)
 * 
 * <VARIABLES MAIN>
 * @prop {string} GlobarlLayerID - ID de la Layer global (MAIN)
 * 
 * <INTERFACE functions>
 * @prop {function({A: string}):{return:HTMLelement}} FuncionDePrueba funcion de prueba
 *
 * <MAIN Function>
 * @prop { (projection:string) => void } setProjectionOnMap - Setea la Proyeccion en el mapa, projection: string deberia ser "EPSG:NUMERO"
 * @prop { (tipo:string) => string } GetDateOnText - Devuelve la fecha segun el parametro de entrada... POSIBLES RESPUESTAS : | "dia" : "DD de Mes del AAAA" | "año" : "AAAA" | "mes" : "Mes del AAAA" | undefined : "DD de Mes del AAAA - XXh XXm" |
 * @prop { () => LayerData[]} GetEditableLayersArray - Devuekve La Lista de Capas Editables
 *
 * <CLASS>
 * @prop {{id: number, Visible: boolean, Nombre: string, Formato: string, GUILayer: HTMLElement, OpenLayerSource: Layer, Listado: boolean, Opacacity: number, CapaPreCargada:boolean, Metadata: string, EstadoDeLaCapa: string, CapaDescargable: boolean, Attributions: HTMLElement, LayerTitles: string[], LayerNames: string[] }} LayerData - Clase LayerData, tiene todos los datos extras necesarios para la interface sobre las Capas del mapa
 * @prop {{Nombre:string, Title:string, Fields:string[], Values:string[], ServerType:string }} ResultLayerGetInfo - Clase ResultLayerGetInfo, tiene todos los datos de la respuesta del CheckInfo WMS
 *
 */

/** widnow element pero documentable
 * @typedef {Window & Globals} ExtendedWindow
 * @typedef {Object} Globals
 *
 * VARIABLES RECURSOS
 * @prop {Recursos} Recursos - elemento global con los recursos
 *
 * Recursos functions
 * @prop {function():void} GetRecursosDiv Obtiene los recursos del div de recursos y los guarda en el objeto global Recursos
 * @prop {function(string):HTMLelement} GetRecurso Obtiene el recurso con el nombre pasado por parametro
 */

/** documentando objeto w.Recursos
 * @typedef {object} Recursos - elemento global con los recursos
 * @prop {string} Recursos.descripcion - descripcion del elemento global de recursos
 * 
 * @prop {HTMLElement} Recursos.div - div con los recursos 
 * 
 * @prop {HTMLElement} Recursos.W_Next - (<img> tipo SVG) Flecha que apunta a la derecha 
 * @prop {HTMLElement} Recursos.W_Prev - (<img> tipo SVG) Flecha que apunta a la Izquierda
 */